import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import PriceDisplay from '../../../../commonComponents/PriceDisplay';
import RadioBtn from '../../../../commonComponents/forms/inputs/RadioBtn';
import PlanProp from '../../../plan/propTypes/planProp';

function SubscriptionPlanCard({
  t,
  img,
  plan,
  title,
  summary,
  userPrice,
  isChecked,
  setSelectedPlan,
  userPromotionPrice,
  showCheckbox = true,
  error,
}) {
  const handleCardClick = useCallback(() => {
    setSelectedPlan(plan);
  }, [plan]);

  return (
    <div
      role="presentation"
      onClick={handleCardClick}
      className="subscription-plan-modal-card"
    >
      <div
        className={
          showCheckbox
            ? 'subscription-plan-modal-card-image'
            : 'subscription-plan-modal-card-image-horizontal'
        }
      >
        <img src={img} alt={title} />
      </div>
      <div className="subscription-plan-modal-card-content">
        <h3>{title}</h3>
        <PriceDisplay
          t={t}
          frequency={plan?.interval}
          userPrice={userPrice}
          userPromotionPrice={userPromotionPrice}
        />
        <p>{summary}</p>
      </div>
      {showCheckbox && (
        <RadioBtn id={plan?._id} checked={isChecked} disabled={!!error} />
      )}
    </div>
  );
}

SubscriptionPlanCard.propTypes = {
  t: PropTypes.func.isRequired,
  img: PropTypes.string.isRequired,
  plan: PropTypes.shape(PlanProp.propType).isRequired,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  userPrice: PropTypes.shape({}).isRequired,
  isChecked: PropTypes.bool,
  setSelectedPlan: PropTypes.func,
  userPromotionPrice: PropTypes.shape({}).isRequired,
  showCheckbox: PropTypes.bool,
  error: PropTypes.string,
};

SubscriptionPlanCard.defaultProps = {
  showCheckbox: false,
  isChecked: false,
  setSelectedPlan: () => {},
  error: null,
};

export default SubscriptionPlanCard;
